import { VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { dropDownFormStyle } from 'components/forms/new/formStyles';

import appConfig from '@/config.json';

const DayFormatField = ({ values, setFieldValue, FormFieldWithTooltip }) => {
    const { darkMode } = useSelector((state) => state.settings);

    const dayOptions = useMemo(
        () =>
            appConfig.datetime.weekday.map((day) => ({
                ...day,
                id: day.name,
            })),
        [],
    );

    return (
        <FormFieldWithTooltip
            label="Day"
            tooltipLabel="Select the format for displaying the day of the week (e.g., 'Fri', 'Friday', 'F.')."
            fieldKey="weekday">
            <Field>
                {({ field }) => (
                    <VStack width="100%" alignItems="normal">
                        <Select
                            {...field}
                            tabSelectsValue
                            openMenuOnFocus
                            options={dayOptions}
                            value={dayOptions.find(
                                (o) => o.id === values?.timeZone?.weekday,
                            )}
                            getOptionLabel={(o) => o.value}
                            getOptionValue={(o) => o.id}
                            chakraStyles={dropDownFormStyle(darkMode)}
                            onChange={(e) => {
                                setFieldValue('timeZone', {
                                    ...values?.timeZone,
                                    weekday: e.name,
                                });
                            }}
                            selectedOptionColor="brand"
                            size="md"
                        />
                    </VStack>
                )}
            </Field>
        </FormFieldWithTooltip>
    );
};

export default DayFormatField;
